<script setup lang="ts">

</script>

<template>
    <h3 class="dropdown-header">
        <slot />
    </h3>
</template>